{
  "version": 1,
  "asset_id": "38e9f19a-ab95-4514-82c9-c945498623c9",
  "project_id": "6ffb2ed6-aa93-4c00-8eaf-179cce7a3ceb",
  "url": "/__l5e/assets-v1/38e9f19a-ab95-4514-82c9-c945498623c9/flow-haircut-1-1.webp",
  "r2_key": "a/v1/6ffb2ed6-aa93-4c00-8eaf-179cce7a3ceb/38e9f19a-ab95-4514-82c9-c945498623c9/flow-haircut-1-1.webp",
  "original_filename": "flow-haircut-1-1.webp",
  "size": 82484,
  "content_type": "image/webp",
  "created_at": "2026-09-09T09:54:21Z"
}
